export default __webpack_public_path__ + "static/media/compass_01.2f6b7878.png";